<p-toast></p-toast>

<!-- Page Header -->
<div class="page-header">
  <h1 class="page-title">Plans</h1>
  <div class="header-actions">
    @if (canDelete && hasSelection) {
      <button class="btn-danger" type="button" (click)="deleteSelected()" [disabled]="isProjectInactive">
        <i class="ri-delete-bin-line"></i>
        <span>Delete ({{ selectedCount }})</span>
      </button>
    }
    @if (canCreate) {
      <button class="btn-outline" type="button" (click)="showAddPlanFolderDialog = true" [disabled]="isProjectInactive">
        <i class="ri-folder-add-line"></i>
        <span>New Folder</span>
      </button>
      <button class="btn-primary" type="button" (click)="showAddPlanDialog = true" [disabled]="isProjectInactive">
        <i class="ri-add-line"></i>
        <span>New Plan</span>
      </button>
    }
  </div>
</div>

<!-- Plans Body -->
<div class="plans-body">
  @for (folder of filteredFolderList; track folder.planFolderId) {
    <div class="folder-section">

      <!-- Folder Header Row -->
      <div class="folder-header-row" (click)="toggleFolderCollapse(folder.planFolderId)">
        <div class="folder-header-left">
          <button class="collapse-btn" type="button" (click)="$event.stopPropagation(); toggleFolderCollapse(folder.planFolderId)">
            <i [class]="isFolderCollapsed(folder.planFolderId) ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'"></i>
          </button>
          <span class="folder-name">
            {{ folder.folderName }}
            ({{ folder.projectPlanList?.length || 0 }} {{ (folder.projectPlanList?.length === 1) ? 'plan' : 'plans' }})
          </span>
        </div>
        @if (canCreate) {
          <button class="btn-add-plan" type="button" (click)="$event.stopPropagation(); onAddPlanToFolder(folder)" [disabled]="isProjectInactive">
            <i class="ri-add-line"></i>
            <span>Add Plan</span>
          </button>
        }
      </div>

      <!-- Plans Content -->
      @if (!isFolderCollapsed(folder.planFolderId)) {
        <div class="folder-content">
          @if (!folder.projectPlanList || folder.projectPlanList.length === 0) {
            <div class="empty-folder">
              <i class="ri-inbox-line"></i>
              <span>No plans in this folder</span>
            </div>
          } @else {
            <div class="thumbnails-grid">
              @for (group of groupPlansByName(folder.projectPlanList); track group.planName) {
                @for (plan of group.pages; track plan.planId) {
                  <div class="plan-card" [class.plan-card--selected]="isPlanSelected(plan.planId)" (click)="openPlanInViewer(plan)">
                    <div class="plan-card-image">
                      @if (canDelete) {
                        <button
                          class="plan-checkbox"
                          [class.plan-checkbox--checked]="isPlanSelected(plan.planId)"
                          type="button"
                          (click)="togglePlanSelection(plan.planId, $event)"
                          title="Select plan">
                          @if (isPlanSelected(plan.planId)) {
                            <i class="ri-check-line"></i>
                          }
                        </button>
                      }
                      @if (plan.isLoading) {
                        <div class="plan-card-placeholder">
                          <i class="ri-loader-4-line"></i>
                        </div>
                      } @else if (plan.thumbnailUrl) {
                        <img [src]="plan.thumbnailUrl" [appMediaFallback]="plan.planThumbnailPath || plan.planPath" [alt]="plan.planFullName || 'Plan'" class="plan-thumbnail" />
                        <div class="plan-card-overlay">
                          <div class="plan-card-actions">
                            @if (canUpdate) {
                              <button class="overlay-btn" type="button" (click)="$event.stopPropagation(); onEditPlan(plan)" [disabled]="isProjectInactive" title="Edit">
                                <i class="ri-pencil-line"></i>
                              </button>
                            }
                            <button class="overlay-btn" type="button" (click)="$event.stopPropagation(); downloadMenu.toggle($event)" title="Download">
                              <i class="ri-download-line"></i>
                            </button>
                            <p-menu #downloadMenu [model]="getDownloadMenuItems(plan)" [popup]="true" appendTo="body">
                              <ng-template pTemplate="item" let-item>
                                <a
                                  class="p-menuitem-link"
                                  (click)="$event.preventDefault(); $event.stopPropagation(); item.command?.({ originalEvent: $event, item }); downloadMenu.hide()">
                                  <span [class]="'p-menuitem-icon ' + item.icon"></span>
                                  <span class="p-menuitem-text">{{ item.label }}</span>
                                </a>
                              </ng-template>
                            </p-menu>
                          </div>
                        </div>
                      } @else {
                        <div class="plan-card-placeholder">
                          <i class="ri-file-line"></i>
                          <span>No Preview</span>
                        </div>
                      }
                    </div>
                    <div class="plan-card-label">
                      @if (group.isMultiPage && plan.planFullName) {
                        <span>{{ plan.planFullName.replace('.png', '') }}</span>
                      } @else {
                        <span>{{ plan.planName }}</span>
                      }
                      @if (plan.description) {
                        <span class="plan-card-description">{{ plan.description }}</span>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  }

  @if (filteredFolderList.length === 0) {
    <div class="empty-state">
      <i class="ri-folder-open-line"></i>
      <p class="empty-title">No folders available</p>
      <p class="empty-subtitle">Create a folder to start adding plans</p>
    </div>
  }
</div>

<!-- Create Folder Dialog -->
<p-dialog
    header="Create Folder"
    [modal]="true"
    [(visible)]="showAddPlanFolderDialog"
    [style]="{ width: '25rem' }"
    [contentStyle]="{ overflow: 'hidden', padding: '0' }"
    styleClass="kansei-dialog plans-folder-dialog">
    <div class="folder-dialog">
        <div class="folder-dialog-content">
            <div class="grid">
                <div class="col-12">
                    <label for="folderName" class="modal-label">Folder Name</label>
                    <input type="text" pInputText id="folderName" [(ngModel)]="projectPlanFolderModel.folderName" class="w-full" />
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="modal-btn-cancel" (click)="showAddPlanFolderDialog = false">Cancel</button>
            <button type="button" class="modal-btn-primary" (click)="addPlanFolder()" [disabled]="!canCreate || isProjectInactive">Save</button>
        </div>
    </div>
</p-dialog>

<!-- Upload Plans Dialog -->
<p-dialog
    header="Upload Plans"
    [modal]="true"
    [(visible)]="showAddPlanDialog"
    [style]="{ width: '50rem' }"
    [contentStyle]="{ overflow: 'hidden', padding: '0' }"
    styleClass="kansei-dialog plans-upload-dialog">
    <div class="upload-plan-dialog">
        <div class="upload-plan-content">
            <div class="fileupload-modal-wrapper">
                <p-fileupload class="fileupload-full" name="demo[]" customUpload="true" showUploadButton="false"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg" [multiple]="true" maxFileSize="524288000" mode="advanced"
                    (onSelect)="onFileSelect($event)" (onRemove)="onFileRemove($event)" (onClear)="onFileClear()" [disabled]="!canCreate || isProjectInactive">
                    <ng-template #empty>
                        <div>Drag and drop files to here to upload.</div>
                    </ng-template>
                </p-fileupload>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="modal-btn-cancel" (click)="showAddPlanDialog = false">Cancel</button>
            <button type="button" class="modal-btn-primary" (click)="addProjectPlan()" [disabled]="!canCreate || isProjectInactive">Save</button>
        </div>
    </div>
</p-dialog>

<!-- Edit Plan Dialog -->
<p-dialog
    header="Edit Plan"
    [modal]="true"
    [(visible)]="showEditPlanDialog"
    [style]="{ width: '35rem' }"
    [contentStyle]="{ overflow: 'hidden', padding: '0' }"
    styleClass="kansei-dialog plans-edit-dialog">
    <div class="edit-plan-dialog">
        <div class="edit-plan-content">
            <div class="grid">
                <div class="col-12">
                    <label for="planFullName" class="modal-label">Plan Name</label>
                    <input type="text" pInputText id="planFullName" [(ngModel)]="editingPlan.planFullName" class="w-full" />
                </div>
                <div class="col-12">
                    <label for="description" class="modal-label">Description</label>
                    <textarea pInputTextarea id="description" [(ngModel)]="editingPlan.description" class="w-full" rows="5"></textarea>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="modal-btn-cancel" (click)="showEditPlanDialog = false">Cancel</button>
            <button type="button" class="modal-btn-primary" (click)="updatePlan()" [disabled]="!canUpdate || isProjectInactive">Save</button>
        </div>
    </div>
</p-dialog>

<!-- Delete Confirm Dialog -->
<p-dialog header="Delete Plans" [modal]="true" [(visible)]="showDeleteConfirmDialog" [style]="{ width: '24rem' }">
  <p class="confirm-msg">Are you sure you want to delete {{ selectedCount }} plan(s)? This action cannot be undone.</p>
  <div class="confirm-footer">
    <button class="confirm-btn-cancel" type="button" (click)="showDeleteConfirmDialog = false">Cancel</button>
    <button class="confirm-btn-delete" type="button" (click)="confirmDelete()">Delete</button>
  </div>
</p-dialog>
